import { ReactComponent as SvgQuoteIcon } from '@img/icons/blockquote-icon.svg';
import { BackgroundValues } from '@stories/Components/Breadcrumb/Breadcrumb';
import CtaLink from '@stories/Components/CtaLink/CtaLink';
import { useCarouselContext } from '@stories/Components/Misc/Carousel/CarouselProvider/CarouselProvider';
import * as React from 'react';
import S from './Testimonial.styles';
const Testimonial = ({ background = BackgroundValues.Beige, values, }) => {
    const context = useCarouselContext();
    return (React.createElement(S.Container, null, values.map((item, i) => (React.createElement(S.TestimonialWrapper, { key: `testimonial-content-key-${item.name}`, "data-is-showing": i === context.activeIndex },
        item.testimonialTitle && (React.createElement(S.TestimonialTitle, null, item.testimonialTitle)),
        item.subtitle && React.createElement(S.Subtitle, null, item.subtitle),
        !item.hideQuoteMarks && React.createElement(SvgQuoteIcon, null),
        React.createElement(S.Text, { dangerouslySetInnerHTML: { __html: item.text } }),
        item.title || item.name ? (React.createElement(S.AccreditationWrapper, null,
            item.title && React.createElement(S.Title, null, item.title),
            item.name && React.createElement(S.Name, null, item.name))) : null,
        item.cta && item.cta.url ? (React.createElement(CtaLink, { href: item.cta.url, target: item.cta.target, variant: background === 'green' ? 'white' : 'default' }, item.cta.text)) : null)))));
};
export default Testimonial;
